module.exports = __webpack_public_path__ + "static/sportsconnect_local-clubs-and-leagues-7a6ce254e96406df1ae454e9458b4eb4.jpg";